module.exports = __webpack_public_path__ + "static/media/Hydraulics-Valves-Comparison@3x-100.8961869a.png";